import Event from '../../core/Event';
import { Month } from '../../../view/admin/getEstimationMonths';
import Product from '../../../domain/Product';

export default class EstimationChangeConfirmed extends Event {
    public static type = 'EstimationChangeConfirmed';

    constructor(
        public readonly discountRate: number,
        public readonly product: Product,
        public readonly sku: string,
        public readonly variantCode: string,
        public readonly month: Month,
        public readonly value: number
    ) {
        super(EstimationChangeConfirmed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/estimations/events/EstimationChangeConfirmed.ts